import React, { useState, useEffect } from "react"
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'
import QRWebScan from "./QRWebAndNativeScan"



export default function XAccess(props) {
    const [xState, setXState] = useState(0);

    useEffect(() => {
        // xState effect logic
    }, [xState])


    return (
        <>
            {/* Click button at the top remains unchanged */}
            
                <Button variant="primary" onClick={() => { if (props.onToggle) props.onToggle(); }} className="  hoverX">
                       <span className="circle-btn centerCircle">🔒</span>
                     Scanner
                </Button>
           

            <Offcanvas show={props.isOpen} onHide={() => { if (props.onToggle) props.onToggle(); }} backdropClassName="adminBackdrop" className="bg-dark" placement="end" >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <h3 className="modified xTitle animated rollIn">
                            Access
                        </h3>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <QRWebScan></QRWebScan>
                 
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}